import { render, staticRenderFns } from "./wechatSidebar.vue?vue&type=template&id=4ae30d25&scoped=true&"
import script from "./wechatSidebar.vue?vue&type=script&lang=js&"
export * from "./wechatSidebar.vue?vue&type=script&lang=js&"
import style0 from "./wechatSidebar.vue?vue&type=style&index=0&id=4ae30d25&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ae30d25",
  null
  
)

export default component.exports